import {
    LINEUP_TEMPLATE,
    SEARCH_INPUT_TEXT,
    PARTICIPANT_PITCH,
    ID_LINEUP,
    LINEUP_TYPE,
    PARTICIPANT_CUSTOM_NAME,
    PARTICIPANT_CUSTOM_TEXT,
    PITCH_LINEUP_TEMPLATE
} from './constants';
import { SET, DELETE, POST, GENERATE, START, SUCCESS, FAIL } from '../constants';

const makerToolPageDefault = {
    idLineUp: 0,
    lineupType: '',
    lineupTemplate: '',
    searchInputText: '',
    mapPitchPos: {},
    activeParticipants: {},
    customPitchLineupList: [],
    pitchLineupStatus: '',
    pitchLineupLoading: false
};

const generateMap = obj =>
    Object.entries(obj).reduce((acc, [key, curr]) => {
        return { ...acc, [curr.positionCode]: key };
    }, {});

const filterPos = (obj, pos) =>
    Object.entries(obj).reduce((acc, [key, val]) => {
        if (parseInt(val.positionCode, 10) === parseInt(pos, 10)) {
            return { ...acc };
        }

        return { ...acc, [key]: val };
    }, {});

export default (makerToolPage = makerToolPageDefault, { type, payload }) => {
    switch (type) {
        case SET + ID_LINEUP:
            return { ...makerToolPage, idLineUp: payload.idLineUp };
        case SEARCH_INPUT_TEXT:
            return { ...makerToolPage, searchInputText: payload.text };
        case SET + LINEUP_TYPE:
            return { ...makerToolPage, lineupType: payload.type };
        case SET + LINEUP_TEMPLATE:
            return { ...makerToolPage, lineupTemplate: payload.template };
        case SET + PARTICIPANT_CUSTOM_NAME:
            return {
                ...makerToolPage,
                activeParticipants: {
                    ...makerToolPage.activeParticipants,
                    [payload.id]: { ...makerToolPage.activeParticipants[payload.id], name: payload.text }
                }
            };
        case SET + PARTICIPANT_CUSTOM_TEXT:
            return {
                ...makerToolPage,
                activeParticipants: {
                    ...makerToolPage.activeParticipants,
                    [payload.id]: { ...makerToolPage.activeParticipants[payload.id], customText: payload.text }
                }
            };
        case SET + PARTICIPANT_PITCH: {
            let activeParticipants = filterPos(makerToolPage.activeParticipants, payload.position);

            activeParticipants = {
                ...activeParticipants,
                [payload.participant.id]: { ...payload.participant, positionCode: payload.position }
            };

            return {
                ...makerToolPage,
                activeParticipants,
                mapPitchPos: generateMap(activeParticipants)
            };
        }
        case DELETE + PARTICIPANT_PITCH: {
            const activeParticipants = filterPos(makerToolPage.activeParticipants, payload.position);

            return {
                ...makerToolPage,
                activeParticipants,
                mapPitchPos: generateMap(activeParticipants)
            };
        }
        case GENERATE + PARTICIPANT_PITCH: {
            const customPitchLineupList = [];
            const lineupTemplate = makerToolPage.lineupTemplate.split('-').map(item => parseInt(item, 10));
            const lineupTemplateLength = lineupTemplate.length;

            for (let row = 1; row <= lineupTemplateLength; row++) {
                for (let item = 1; item <= lineupTemplate[row - 1]; item++) {
                    const customPitchLineupItem =
                        makerToolPage.activeParticipants[makerToolPage.mapPitchPos[`${row}${item}`]];

                    if (customPitchLineupItem) {
                        customPitchLineupList.push(customPitchLineupItem);
                    } else {
                        customPitchLineupList.push({
                            id: Math.floor(10000 + Math.random() * 90000),
                            name: 'Unknown',
                            positionCode: `${row}${item}`,
                            customText: '',
                            unknown: true
                        });
                    }
                }
            }

            return { ...makerToolPage, customPitchLineupList };
        }
        case SET + PITCH_LINEUP_TEMPLATE: {
            const activeParticipants = payload.template.reduce(
                (acc, curr) => (curr.unknown ? { ...acc } : { ...acc, [curr.id]: curr }),
                {}
            );

            return {
                ...makerToolPage,
                activeParticipants,
                mapPitchPos: generateMap(activeParticipants),
                customPitchLineupList: payload.template
            };
        }
        case POST + PARTICIPANT_PITCH + START:
            return { ...makerToolPage, pitchLineupLoading: true };
        case POST + PARTICIPANT_PITCH + SUCCESS:
            return { ...makerToolPage, pitchLineupStatus: 'success', pitchLineupLoading: false };
        case POST + PARTICIPANT_PITCH + FAIL:
            return { ...makerToolPage, pitchLineupStatus: 'fail', pitchLineupLoading: false };
        default:
            return makerToolPage;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/reducer.js
 **/